export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('hp5', {
    beforeMount(el, { arg, value }) {
        el.addEventListener(arg, value)
    },
    beforeUnmount(el, { arg, value }) {
        el.removeEventListener(arg, value)
    }
  })
})